{
    "CommonAdminAllTelServer": "[All Telephony Servers]",
    "CommonAdminAnyPartition": "[Any Partition]",
    "CommonAdminAnyDevices": "[Any Device]",
    "CommonAdminAnyAgents": "[Any ACD Agent]",
    "CommonAdminAnyAgentForDevice": "[Any At Set Device]",
    "CommonAdminAnyDeviceForAgent": "[Any With Set ACD Agent]",
    "CommonAdminUnknownOrDeleted": "[Unknown or Deleted]",
    "NAME": "CommonAdmin"
}